<template>
  <Header :title="$t('sidebar.menu.reports_title')" />
  <div v-if="isPermissionDenied">
    <PermissionAlert :message="$t('common.no_permission')" />
  </div>
  <div v-else style="display: flex; width: 100%; gap: 8px" :class="{ onCollapse: !isSidebarOpen }">
    <!-- Sidebar -->
    <div class="jobHistorySidebarStack">
      <div v-if="isSidebarOpen" style="width: 100%">
        <div class="jobHistoryFilterContainer">
          <div class="jobHistoryHeaderFilter">
            <div class="headerBar">
              <div class="jobHeader" @click="toggleSidebarDropdown">
                <img src="/arrowDown.png" alt="Arrow Icon" class="arrowDownIcon" :class="{ rotated: !isSidebarListOpen }" />
                <span class="jobsTitle">{{ $t('reports.sidebar_title') }}</span>
              </div>

              <div @click="toggleSidebar">
                <img :class="{ rotated: !isSidebarOpen }" src="/hideSidebar.png" alt="Toggle Sidebar" />
              </div>
            </div>
            <div class="configureList" v-if="isSidebarListOpen">
              <div v-for="({ name }, idx) in reportList" :key="idx" class="jobItem" :class="{ jobItemActive: selectedReport === name }" @click="selectReport(name)">
                <div v-if="selectedReport === name" class="vrCustom" />
                <span class="jobItemTitle">{{ name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Collapsed Sidebar -->
      <div v-if="!isSidebarOpen" class="jobHistoryFilterSidebar">
        <div class="jobHistoryHeaderFilterSideBarOpen">
          <div class="jobHistoryHeaderFilter">
            <div @click="toggleSidebar">
              <img :class="{ rotated: !isSidebarOpen }" src="/hideSidebar.png" alt="Toggle Sidebar" />
            </div>

            <div style="display: flex; flex-direction: column; justify-content: space-between">
              <div class="jobItemsSidebar">
                <!-- <div style="background-color: #d1e6f1; padding: 2px; display: flex; justify-content: center">
                  <span style="font-size: 12px; color: white; font-weight: bold">REPORTS</span>
                </div> -->

                <div v-for="({ name, icon }, idx) in reportList" :key="idx" class="jobItemSidebarOpen" :class="{ jobItemActive: selectedReport === name }" @click="selectReport(name)">
                  <div v-if="selectedReport === name" class="vrCustom" />
                  <img :src="icon" :alt="`${name} Icon`" class="configureItemIcon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="pageContainerJob">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding-top: 18px">
        <p class="jobHistoryTitle">{{ selectedReport }}</p>

        <div v-if="selectedReportSlug !== 'audit' && selectedReportSlug !== 'billing' && selectedReportSlug !== 'subscription-expiry' && selectedReportSlug !== 'licensed-page-expiry'" class="filterAndSearch" style="display: flex; align-items: center; gap: 24px">
          <div class="dayFilterGroup">
            <button v-for="option in filterOptions" :key="option.key" :class="['dayFilterButton', { selected: selectedFilter === option.key }]" @click="selectFilter(option.key)">
              {{ option.label }}
            </button>
          </div>
        </div>
      </div>

      <div v-if="selectedReportSlug !== 'audit' && selectedReportSlug !== 'billing' && selectedReportSlug !== 'subscription-expiry' && selectedReportSlug !== 'licensed-page-expiry'" class="dateRangeFilterGroup">
        <label class="dateLabel">{{ $t('reports.from') }}</label>
        <div class="dateInputWrapper">
          <input type="date" class="dateInput" placeholder="mm/dd/yy" v-model="fromDate" />
        </div>
        <label class="dateLabel">{{ $t('reports.to') }}</label>
        <div class="dateInputWrapper">
          <input type="date" class="dateInput" placeholder="mm/dd/yy" v-model="toDate" />
        </div>
        <button class="resetDateButton" @click="resetDateRange">{{ $t('reports.reset') }}</button>
      </div>

      <div class="newJobHistoryContainer" :class="{ auditContainer: selectedReportSlug === 'audit' || selectedReportSlug === 'billing' || selectedReportSlug === 'subscription-expiry' || selectedReportSlug === 'licensed-page-expiry' }">
        <div v-if="selectedReportSlug !== 'audit' && selectedReportSlug !== 'billing' && selectedReportSlug !== 'subscription-expiry' && selectedReportSlug !== 'licensed-page-expiry'" class="customLegend">
          <span class="legendItem"><span class="legendColor completed"></span>{{ $t('reports.legend.completed') }}</span>
          <span class="legendItem"><span class="legendColor processed"></span>{{ $t('reports.legend.processed') }}</span>
          <span class="legendItem"><span class="legendColor failed"></span>{{ $t('reports.legend.failed') }}</span>
        </div>
        <div style="width: 100%; max-width: 100%" :class="{ auditWrapper: selectedReportSlug === 'audit' || selectedReportSlug === 'billing' || selectedReportSlug === 'subscription-expiry' || selectedReportSlug === 'licensed-page-expiry' }">
          <BarChart v-if="selectedReportSlug === 'job-processed'" :chart-data="jobProcessedData" :options="chartOptions" />
          <BarChart v-else-if="selectedReportSlug === 'document-processed'" :chart-data="documentProcessedData" :options="chartOptions" />
          <BarChart v-else-if="selectedReportSlug === 'pages-processed'" :chart-data="pagesProcessedData" :options="chartOptions" />
          <AuditReport v-else-if="selectedReportSlug === 'audit'" />
          <BillingReport v-else-if="selectedReportSlug === 'billing'" />
          <SubscriptionExpiryReport v-else-if="selectedReportSlug === 'subscription-expiry'" />
          <LicensedPageExpiryReport v-else-if="selectedReportSlug === 'licensed-page-expiry'" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import BarChart from '../../components/BarChart.vue'
import AuditReport from './AuditReport.vue'
import BillingReport from './BillingReport.vue'
import SubscriptionExpiryReport from './SubscriptionExpiryReport.vue'
import LicensedPageExpiryReport from './LicensedPageExpiryReport.vue'
import PermissionAlert from '../../components/PermissionAlert.vue'

export default {
  components: { Header, BarChart, AuditReport, BillingReport, SubscriptionExpiryReport, LicensedPageExpiryReport, PermissionAlert },
  props: {
    reportType: {
      type: String,
      default: 'job-processed',
    },
  },
  data() {
    return {
      isSidebarOpen: true,
      isSidebarListOpen: true,
      selectedReport: '',
      selectedReportSlug: '', // Add slug tracking
      reportList: [],
      filterOptions: [],
      selectedFilter: 'week',
      fromDate: '',
      toDate: '',
      isPermissionDenied: false,
      jobProcessedData: {
        labels: ['0', '1', '2', '3', '4'],
        datasets: [
          { label: this.$t('reports.legend.completed'), backgroundColor: '#164863', data: [3, 6, 13, 5, 7] },
          { label: this.$t('reports.legend.processed'), backgroundColor: '#337497', data: [12, 16, 14, 7, 17] },
          { label: this.$t('reports.legend.failed'), backgroundColor: '#7AC4EB', data: [10, 7, 13, 11, 6] },
        ],
      },
      documentProcessedData: {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        datasets: [
          { label: this.$t('reports.legend.completed'), backgroundColor: '#164863', data: [2, 8, 10, 4, 9] },
          { label: this.$t('reports.legend.processed'), backgroundColor: '#337497', data: [10, 14, 12, 8, 15] },
          { label: this.$t('reports.legend.failed'), backgroundColor: '#7AC4EB', data: [8, 5, 11, 9, 5] },
        ],
      },
      pagesProcessedData: {
        labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
        datasets: [
          { label: this.$t('reports.legend.completed'), backgroundColor: '#164863', data: [5, 7, 12, 6, 8] },
          { label: this.$t('reports.legend.processed'), backgroundColor: '#337497', data: [14, 18, 15, 10, 19] },
          { label: this.$t('reports.legend.failed'), backgroundColor: '#7AC4EB', data: [9, 6, 12, 10, 7] },
        ],
      },
      chartOptions: {
        responsive: true,
        plugins: {
          legend: { display: false },
          title: { display: false },
        },
        scales: {
          x: { stacked: false },
          y: { beginAtZero: true },
        },
      },
    }
  },
  watch: {
    // Watch for route parameter changes
    reportType: {
      immediate: true,
      handler(newReportType) {
        this.updateSelectedReport(newReportType)
      },
    },
    '$route.params.reportType': {
      immediate: true,
      handler(newReportType) {
        if (newReportType) {
          this.updateSelectedReport(newReportType)
        }
      },
    },
  },
  mounted() {
    this.checkPermissions()

    // Initialize filter options with translations
    this.filterOptions = [
      { key: 'day', label: this.$t('reports.filters.day') },
      { key: 'week', label: this.$t('reports.filters.week') },
      { key: 'month', label: this.$t('reports.filters.month') },
      { key: 'year', label: this.$t('reports.filters.year') },
    ]

    // Set default selected report - use first available report
    if (this.reportList.length > 0) {
      this.selectedReport = this.reportList[0].name
      this.selectedReportSlug = this.reportList[0].slug
    }

    // Initialize based on route parameter
    const routeReportType = this.$route.params.reportType || this.reportType
    this.updateSelectedReport(routeReportType)
  },
  methods: {
    checkPermissions() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      // Check if user has any report permissions
      const hasAuditRead = permissions.some((p) => p.object_name === 'AUDIT_LOG_RD' && p.is_active)
      const hasBillingRead = permissions.some((p) => p.object_name === 'BILLING_REPORT_RD' && p.is_active)
      const hasSubscriptionRead = permissions.some((p) => p.object_name === 'SUBSCRIPTION_EXPIRY_REPORT_RD' && p.is_active)
      const hasLicenseRead = permissions.some((p) => p.object_name === 'LICENSE_PAGE_EXPIRY_REPORT_RD' && p.is_active)

      // If user has no read permissions for any report, deny access
      if (!hasAuditRead && !hasBillingRead && !hasSubscriptionRead && !hasLicenseRead) {
        this.isPermissionDenied = true
        return
      }

      this.isPermissionDenied = false

      // Build report list based on permissions
      this.buildReportList()
    },

    buildReportList() {
      const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
      this.reportList = []

      // Add reports based on permissions
      if (permissions.some((p) => p.object_name === 'AUDIT_LOG_RD' && p.is_active)) {
        this.reportList.push({ name: this.$t('reports.types.audit'), icon: '/reportIcon.svg', slug: 'audit' })
      }

      if (permissions.some((p) => p.object_name === 'BILLING_REPORT_RD' && p.is_active)) {
        this.reportList.push({ name: this.$t('reports.types.billing'), icon: '/reportIcon.svg', slug: 'billing' })
      }

      if (permissions.some((p) => p.object_name === 'SUBSCRIPTION_EXPIRY_REPORT_RD' && p.is_active)) {
        this.reportList.push({ name: this.$t('reports.types.subscription_expiry'), icon: '/reportIcon.svg', slug: 'subscription-expiry' })
      }

      if (permissions.some((p) => p.object_name === 'LICENSE_PAGE_EXPIRY_REPORT_RD' && p.is_active)) {
        this.reportList.push({ name: this.$t('reports.types.licensed_page_expiry'), icon: '/reportIcon.svg', slug: 'licensed-page-expiry' })
      }
    },

    updateSelectedReport(reportTypeSlug) {
      if (!reportTypeSlug) return

      const report = this.reportList.find((report) => report.slug === reportTypeSlug.toLowerCase())

      if (report) {
        this.selectedReport = report.name
        this.selectedReportSlug = report.slug
      }
    },
    toggleSidebarDropdown() {
      this.isSidebarListOpen = !this.isSidebarListOpen
    },
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen
    },
    navigateToReport(reportName) {
      const report = this.reportList.find((r) => r.name === reportName)
      if (!report) return

      const tenantName = this.$route.params.tenantName

      this.$router
        .push({
          name: 'ReportType',
          params: {
            tenantName: tenantName,
            reportType: report.slug,
          },
        })
        .catch(() => {}) // Catch navigation duplicated error
    },
    selectReport(name) {
      this.selectedReport = name
      const report = this.reportList.find((r) => r.name === name)
      if (report) {
        this.selectedReportSlug = report.slug
      }
      this.navigateToReport(name)
    },
    selectFilter(option) {
      this.selectedFilter = option
    },
    resetDateRange() {
      this.fromDate = ''
      this.toDate = ''
    },
  },
}
</script>

<style scoped>
@import '@/styles/jobHistory.css';

.arrowDownIcon {
  width: 24px;
  height: 24px;
  transition: transform 0.3s ease;
}

.arrowDownIcon.rotated,
.rotated {
  transform: rotate(-180deg);
}

.configureItemIcon {
  width: 40px;
  height: 40px;
}

/* Smaller icons in collapsed sidebar */
.jobItemSidebarOpen .configureItemIcon {
  width: 28px;
  height: 28px;
}

.headerBar {
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;
  align-items: center;
  padding: 0 8px;
}

.headerBar > div:last-child img {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.headerBar > div:last-child {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
}

.jobHistorySidebarStack {
  display: flex;
  flex-direction: column;
  height: 80vh;
}

.jobItem {
  cursor: pointer;
}

.activeItem {
  background-color: #d1e6f1;
}

.jobItemSidebarOpen {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 6px;
  margin: 3px 0;
  border-radius: 4px;
  transition: background-color 0.2s;
  min-height: 40px;
}

.jobItemSidebarOpen:hover {
  background-color: #f0f0f0;
}

.jobItemSidebarOpen.jobItemActive {
  background-color: #d1e6f1;
}

.onCollapse {
  gap: 16px;
}

.onCollapse .pageContainerJob {
  margin-left: 0;
  transition: margin-left 0.3s ease;
}

.pageContainerJob {
  transition: margin-left 0.3s ease;
}

.dayFilterGroup {
  display: flex;
  gap: 16px;
}

.dayFilterButton {
  display: flex;
  width: 85px;
  height: 36px;
  padding: 8px;
  justify-content: center;
  align-items: center;
  gap: 120px;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid var(--Gray-300, #d0d5dd);
  background: var(--White, #fff);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #9b9b9b;
  font-family: Archivo, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  transition: all 0.2s;
  cursor: pointer;
}

.dayFilterButton.selected {
  border-radius: 4px;
  border: 1px solid #7ac4eb;
  background: #e9f6fd;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  color: #164863;
}

.dateRangeFilterGroup {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 60px;
  margin-top: 24px;
}

.dateLabel {
  color: var(--Gray-700, #344054);
  font-family: Archivo;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}

.dateInputWrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.dateInput {
  width: 170px;
  height: 35px;
  padding: 8px 36px 8px 12px;
  border-radius: 6px;
  border: 1px solid #d0d5dd;
  background: #fff;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  color: #344054;
}

.resetDateButton {
  height: 35px;
  padding: 0 24px;
  border-radius: 6px;
  border: none;
  background: #164863;
  color: #fff;
  font-family: Archivo, sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}

.resetDateButton:hover {
  background: #337497;
}

input[type='date']::-webkit-calendar-picker-indicator {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  cursor: pointer;
}

input[type='date']::-ms-input-placeholder {
  color: #bdbdbd;
}

input[type='date']::placeholder {
  color: #bdbdbd;
}

.customLegend {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 24px;
  margin-bottom: 12px;
  width: 100%;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: Archivo, sans-serif;
  font-size: 16px;
  color: #344054;
  font-weight: 500;
}

.legendColor {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  border-radius: 4px;
  display: inline-block;
}

.legendColor.completed {
  background: #164863;
}

.legendColor.processed {
  background: #337497;
}

.legendColor.failed {
  background: #7ac4eb;
}

/* Prevent AuditReport from causing page scroll */
.auditContainer {
  max-height: calc(100vh - 200px);
  overflow: visible;
}

.auditWrapper {
  max-height: calc(100vh - 250px);
  overflow: auto;
  padding-right: 8px;
  width: 500px;
}

/* Hide scrollbar for webkit browsers but keep functionality */
.auditWrapper::-webkit-scrollbar {
  width: 6px;
}

.auditWrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.auditWrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.auditWrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>
